<section class="trinka-banner-img section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h1 class="text-white">Work with Us</h1>
                    <div class="HeadingSubLine1 justify-content-center"><span class="bg-white"></span><span class="bg-white"></span><span class="bg-white"></span></div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <h3>We keep pushing the limits</h3>
                <p class="mb-0">
                    We are a team of 20 passionate individuals who believe in going beyond the state of the art and never say no to a challenge. We have made several advances in natural language processing and AI technology for language enhancement. And we are not slowing down. If you are up for a challenge,
                    <a href="https://www.crimsoni.ai/work-with-us.htm" target="_blank" class="text-link">join us!</a>
                </p>
            </div>
        </div>
    </div>
</section>